import { useEffect, useMemo, useRef, useState } from 'react'
import { useFormikContext } from 'formik'

import { withdrawalSteps } from '../../cryptoPaymentConstants'
import { constants } from '../../../../componentsConstants'
import { getMinMaxValue } from '../../../../services/utils'

export const useModifyDraftWithdrawalData = ({ withdrawalStep, updateDraftWithdrawal, withdrawalDraftData }) => {
  const [secondsToUpdateDraftData, setSecondsToUpdateDraftData] = useState(null)

  const { values } = useFormikContext()

  const updateData = useMemo(
    () => ({
      address: values.address,
      currency: values.currency,
      destinationTag: values.destinationTag,
      protocol: values.protocol
    }),
    [values.address, values.currency, values.destinationTag, values.protocol]
  )

  const expiryDate = useMemo(
    () => getMinMaxValue('min', withdrawalDraftData.acceptanceExpiryDate, withdrawalDraftData.quoteExpiryDate),
    [withdrawalDraftData.acceptanceExpiryDate, withdrawalDraftData.quoteExpiryDate]
  )

  const modifyDraftWithdrawalDataIntervalRef = useRef(null)
  const modifyDraftWithdrawalDataIntervalRunRef = useRef(false)

  useEffect(() => {
    if (withdrawalStep === withdrawalSteps.submit && updateData.address && updateData.currency) {
      updateDraftWithdrawal(updateData)
    }
  }, [updateData])

  useEffect(() => {
    const deltaTimeMs = expiryDate - new Date().getTime()
    const seconds = ((deltaTimeMs % constants.timers['60000']) / constants.timers['1000']).toFixed(0)

    setSecondsToUpdateDraftData(Number(seconds))
  }, [expiryDate])

  useEffect(() => {
    if (
      withdrawalStep === withdrawalSteps.submit &&
      secondsToUpdateDraftData < 1 &&
      modifyDraftWithdrawalDataIntervalRunRef.current
    ) {
      updateDraftWithdrawal(updateData)
    }

    if (secondsToUpdateDraftData !== null && secondsToUpdateDraftData <= 0) {
      setSecondsToUpdateDraftData(null)
      modifyDraftWithdrawalDataIntervalRunRef.current = false

      clearInterval(modifyDraftWithdrawalDataIntervalRef.current)
    }

    if (secondsToUpdateDraftData > 0 && !modifyDraftWithdrawalDataIntervalRunRef.current) {
      modifyDraftWithdrawalDataIntervalRunRef.current = true

      modifyDraftWithdrawalDataIntervalRef.current = setInterval(() => {
        setSecondsToUpdateDraftData(prevValue => prevValue - 1)
      }, constants.timers['1000'])
    }

    if (withdrawalStep === withdrawalSteps.create) {
      setSecondsToUpdateDraftData(null)

      if (modifyDraftWithdrawalDataIntervalRef.current) {
        clearInterval(modifyDraftWithdrawalDataIntervalRef.current)
      }
    }
  }, [secondsToUpdateDraftData])

  useEffect(() => {
    return () => {
      clearInterval(modifyDraftWithdrawalDataIntervalRef.current)
    }
  }, [])

  return { secondsToUpdateDraftData }
}
